import router from '@/router'
import store from '../store'
export default {
    //当不传path参数时，path为当前路由值
    //是否有读权限
    canRead(path = null) {
        return this.can("读", path);
    },
    //是否有写权限
    canWrite(path = null) {
        return this.can("写", path);
    },
    //是否有审核权限
    canReview(path = null) {
        let res1 = this.can("一级审核", path);
        let res2 = this.can("二级审核", path);

        if (res1 == true && res2 == true) {
            return 3; //有一级审核与二级审核
        } else if (res1 == true && res2 == false) {
            return 1; //只有 一级审核
        } else if (res1 == false && res2 == true) {
            return 2; //只有二级审核
        } else if (res1 == false && res2 == false) {
            return 0; //没有审核权限
        } else {
            return 0;
        }
    },
    can(action, path = null) {
        if (!path) {
            path = router.history.current.fullPath;
        }
        // console.log(path);
        // console.log(store.state.sys.permissionMenus);
        return store.state.sys.permissionMenus.some(item => {
            if (item.FullPath == path || item.PermissionPath == path) {
                // console.log(item.FuncNames)
                // console.log(item.FuncNames.indexOf(action) != -1)
                return item.FuncNames.indexOf(action) != -1 || false;
            }
        })
    },
    //是否有某个菜单
    hasMenu(path) {
        return store.state.sys.permissionMenus.some(item => item.fullPath == path || item.permissionPath == path);
    }
}